/**
 * Google AdSense — Wiedereinführung aus v1.
 *
 * v1 hat AdSense über `layouts/partials/_consent.html` eingebunden, und zwar
 * nur im Zweig für anonyme und nicht zahlende Nutzer; Premium-Konten sahen nie
 * Werbung. Genau diese Regel gilt hier wieder.
 *
 * v1 nutzte Auto Ads — nur das Loader-Skript, keine manuell gesetzten
 * `<ins class="adsbygoogle">`-Flächen (im ganzen v1-Repo gibt es keine).
 * Google platziert die Anzeigen selbst. Das bleibt so.
 *
 * Einwilligung: Es gibt hier bewusst KEIN zweites Consent-Gate. Der
 * `consent default` aus lib/analytics.ts setzt `ad_storage` und
 * `ad_personalization` auf `denied`, solange nicht zugestimmt wurde — AdSense
 * liest denselben Consent-Zustand und schaltet dann ausschliesslich nicht
 * personalisierte Anzeigen. Ein eigener Schalter würde nur auseinanderlaufen.
 *
 * ponytail: kein Teardown, falls ein anonymer Besucher (Werbung sichtbar)
 * sich per SPA-Navigation ohne Reload in ein zahlendes Konto einloggt — das
 * bereits geladene Auto-Ads-Skript kennt `shouldLoadAdsNow` nicht und liefert
 * fuer den Rest der Sitzung weiter Anzeigen aus. AdSense bietet keine
 * unterstuetzte Abschalt-API; ein sauberer Fix waere ein harter Reload nach
 * dem Login, was ausserhalb dieser Datei liegt. Aufwand nur lohnend, falls
 * das in der Praxis auftritt (Login direkt nach anonymem Browsen, ohne
 * Reload dazwischen).
 */

import { loadScriptOnce } from './loadScriptOnce'

export const ADSENSE_CLIENT = 'ca-pub-4585303587288351'

/**
 * Zeigt dieses Konto Werbung?
 *
 * Bewusst als Positivliste des freien Tarifs formuliert und nicht als
 * `plan !== 'premium'`: der Katalog kennt neun Tarife (`single`, `starter`,
 * `ideal`, `professional`, `business`, `enterprise`, `enterprisex`,
 * `enterprisexl`, `free`) plus die Alt-ID `premium` aus dem v1-Import. Mit
 * einem Ungleich-Vergleich hätte jeder zahlende Tarif ausser genau "premium"
 * Werbung bekommen.
 *
 * `null`/`undefined` heisst: anonymer Besucher (kein Konto geladen) — der
 * bekommt Werbung wie in v1.
 */
export function shouldShowAds(plan: string | null | undefined): boolean {
  return !plan || plan === 'free'
}

/**
 * Darf JETZT geladen werden?
 *
 * Der Zwischenzustand ist der Punkt: ein angemeldeter Besucher hat direkt nach
 * dem Boot `isAuthenticated`, aber noch keinen geladenen Account. Würde in
 * diesem Moment geladen, sähe ein zahlendes Konto beim Seitenaufbau kurz
 * Werbung aufblitzen. Also: warten (`false`), bis `plan` steht — der Aufrufer
 * fragt erneut, sobald der Account da ist.
 */
export function shouldLoadAdsNow(isAuthenticated: boolean, plan: string | null | undefined): boolean {
  if (isAuthenticated && plan == null) return false
  return shouldShowAds(plan)
}

/** Bindet das AdSense-Loader-Skript ein — einmal pro Seitenaufbau. */
export function loadAds(): void {
  loadScriptOnce(`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`, {
    crossOrigin: 'anonymous',
  })
}
